import { Order } from '../types/orders';
import { OrderSplit } from '../types/splits';
import { formatShare, isWholeShare } from './seats';

/**
 * "Orden sintética" de una cuenta: la orden original con solo los renglones de
 * esa cuenta y las cantidades que le tocaron.
 *
 * Es el truco que deja reusar tal cual todo lo que sabe leer una orden
 * (PaymentModal para cobrar, los servicios de impresión para el ticket) sin
 * enseñarles qué es una cuenta dividida. Los importes vienen prorrateados del
 * backend, así que la suma de las órdenes sintéticas cuadra al centavo con la
 * original.
 *
 * Una fracción (partes iguales: 1/3 de pizza) va como UNA línea al importe
 * prorrateado, con la fracción en el nombre: la impresión y el CFDI trabajan
 * con cantidades enteras.
 */
export function buildSplitOrder(order: Order, split: OrderSplit): Order {
  return {
    ...order,
    orderItems: split.splitItems.map(si => {
      const whole = isWholeShare(si.allocatedQuantity);
      return {
        ...(order.orderItems?.find(oi => oi.id === si.originalOrderItemId) || ({} as any)),
        id: si.id,
        productName: whole ? si.productName : `${formatShare(si.allocatedQuantity)} ${si.productName}`,
        quantity: whole ? Math.round(si.allocatedQuantity) : 1,
        unitPrice: whole ? si.unitPrice : si.total,
        total: si.total,
        isCancelled: false,
        variants: si.variants || [],
      };
    }),
  };
}

/** Lo que se cobra de una cuenta: base IVA-incluido menos descuento, sin propina. */
export const splitChargedAmount = (split: OrderSplit) =>
  split.subtotal + split.tax - split.discountAmount;

/** "2x Café, 1/3 Pizza" — resumen de una cuenta para listas y tickets. */
export const splitItemsSummary = (split: OrderSplit) =>
  split.splitItems.map(si => `${formatShare(si.allocatedQuantity)} ${si.productName}`).join(', ');
